import styled, { keyframes } from 'styled-components';
import { ColDiv } from 'styles';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: none; }
`;

// 실제 설치사례 갤러리 (설치장소 섹션 하단)
export const LocationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  width: 100%;
  margin-top: 32px;

  @media ${({ theme }) => theme.device.tablet} {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  @media ${({ theme }) => theme.device.mobile} {
    grid-template-columns: 1fr;
  }
`;

export const LocationCard = styled(ColDiv)`
  gap: 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.colors.boxShadow};
  background-color: #fff;

  img {
    display: block;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
`;

export const LocationInfo = styled(ColDiv)`
  gap: 4px;
  padding: 16px;
`;

export const ImgBox = styled(ColDiv)`
  box-shadow: ${({ theme }) => theme.colors.boxShadow};
  padding: 32px 0;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  @media ${({ theme }) => theme.device.tablet} {
  }

  @media ${({ theme }) => theme.device.tablet} {
    padding: 92px 0;
  }
`;

export const TextDiv = styled.div`
  text-align: center;
  padding: 8px 0;
  border-radius: 6px;
  background-color: rgba(23, 23, 23, 0.02);
`;

// 제품 스펙 라벨/값 정렬용 그리드 (라벨 열은 가장 긴 라벨 기준으로 자동 폭)
export const SpecGrid = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  column-gap: 16px;
  row-gap: 8px;
  align-items: baseline;
  width: 100%;
`;

// 축사 형태별 설치 사진 갤러리 (제품설치 섹션)
export const InstallGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  width: 100%;

  @media ${({ theme }) => theme.device.mobile} {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const InstallCard = styled(ColDiv)`
  gap: 12px;
  align-items: center;
`;

// 사진마다 크기가 달라도 동일한 비율로 보이도록 고정 비율 + cover
export const InstallImgBox = styled.div`
  width: 100%;
  aspect-ratio: 16 / 10;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.colors.boxShadow};
  background-color: #f4f6f6;

  img {
    border-radius: 8px;
  }
`;

// ===== 설치/운용 지역 인터랙티브 지도 =====
export const MapWrap = styled.div`
  display: flex;
  gap: 40px;
  align-items: center;
  width: 100%;

  @media ${({ theme }) => theme.device.tablet} {
    gap: 24px;
  }
  @media ${({ theme }) => theme.device.mobile} {
    flex-direction: column;
    gap: 20px;
  }
`;

export const MapCanvas = styled.div`
  position: relative;
  flex: 0 0 auto;
  width: 44%;
  max-width: 400px;

  img {
    width: 100%;
    display: block;
    user-select: none;
    -webkit-user-drag: none;
  }

  @media ${({ theme }) => theme.device.mobile} {
    width: 72%;
    max-width: 300px;
  }
`;

export const Pin = styled.button`
  position: absolute;
  /* dot(점)만 앵커 좌표에 정확히 오도록: 라벨은 absolute로 레이아웃에서 제외 */
  transform: translate(-50%, -50%);
  display: block;
  line-height: 0;
  background: none;
  border: 0;
  padding: 0;
  cursor: pointer;
  z-index: ${({ $active }) => ($active ? 3 : 1)};

  .dot {
    display: block;
    width: ${({ $active }) => ($active ? '15px' : '11px')};
    height: ${({ $active }) => ($active ? '15px' : '11px')};
    border-radius: 50%;
    background: ${({ theme, $active }) => ($active ? theme.colors.primary : '#9fb3b5')};
    border: 2px solid #fff;
    box-shadow: 0 0 0 ${({ $active }) => ($active ? '6px' : '0')}
      ${({ theme }) => theme.colors.primary100};
    transition: all 0.2s ease;
  }

  .label {
    position: absolute;
    left: 50%;
    top: calc(100% + 6px);
    transform: translateX(-50%);
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
    color: ${({ theme }) => theme.colors.primary900};
    background: #fff;
    padding: 2px 8px;
    border-radius: 12px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16);
    opacity: ${({ $active }) => ($active ? 1 : 0)};
    transition: opacity 0.2s ease;
    pointer-events: none;
  }

  &:hover .dot {
    background: ${({ theme }) => theme.colors.primary};
  }
  &:hover .label {
    opacity: 1;
  }
`;

export const MapPhoto = styled(ColDiv)`
  flex: 1;
  gap: 12px;
  min-width: 0;
`;

export const MapPhotoImgBox = styled.div`
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.colors.boxShadow};
  background-color: #f4f6f6;
  animation: ${fadeIn} 0.35s ease;

  img {
    border-radius: 10px;
  }
`;

export const MapPhotoCaption = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 8px;
`;

// 한 지역에 농장이 여러 곳일 때 농장 전환 탭
export const GroupTabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
`;

export const GroupTab = styled.button`
  padding: 6px 16px;
  border-radius: 18px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid
    ${({ theme, $active }) => ($active ? theme.colors.primary : '#d4dbdc')};
  background: ${({ theme, $active }) => ($active ? theme.colors.primary : '#fff')};
  color: ${({ theme, $active }) => ($active ? '#fff' : theme.colors.strong)};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const ThumbRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
`;

export const Thumb = styled.button`
  width: 64px;
  height: 48px;
  padding: 0;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  background: #f4f6f6;
  border: 2px solid
    ${({ theme, $active }) => ($active ? theme.colors.primary : 'transparent')};
  opacity: ${({ $active }) => ($active ? 1 : 0.6)};
  transition: opacity 0.2s ease, border-color 0.2s ease;

  &:hover {
    opacity: 1;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;
